import tileNossaFm105 from "./images/nossafm-105.png";
import tileNossaFm96 from "./images/nossafm-96.png";
import tileNtv from "./images/ntv.png";
import tilePatosJa from "./images/patosja.png";
import mascot from "./images/mascot.png";
import mic from "./images/mic.png";

const channels = [
  {
    href: "https://nossafm105.com",
    image: tileNossaFm105,
    name: "Nossa FM 105.9",
    city: "Patos de Minas",
  },
  {
    href: "https://nossafm96.com/",
    image: tileNossaFm96,
    name: "Nossa FM 96.3",
    city: "Oliveira",
  },
  {
    href: "https://ntv.tv.br",
    image: tileNtv,
    name: "NTV, canal 8.1",
  },
  {
    href: "https://patosja.com.br",
    image: tilePatosJa,
    name: "PatosJá",
  },
];

const pillars = [
  {
    title: "Rádio",
    text: "Música e informação",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="8" width="18" height="12" rx="2.5" />
        <circle cx="8.5" cy="14" r="2.5" />
        <path d="M14 12h4M14 16h4M7 8l9-4" />
      </svg>
    ),
  },
  {
    title: "TV",
    text: "Entretenimento e conteúdo",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="7" width="18" height="12" rx="2.5" />
        <path d="M8 3l4 4 4-4M9 22h6" />
      </svg>
    ),
  },
  {
    title: "Notícia",
    text: "Informação com credibilidade",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 5h13v14a2 2 0 0 0 2 2H6a2 2 0 0 1-2-2V5z" />
        <path d="M17 9h3v10a2 2 0 0 1-2 2" />
        <rect x="7" y="8" width="4" height="4" />
        <path d="M13 8h2M13 11h2M7 15h8" />
      </svg>
    ),
  },
  {
    title: "Conectando",
    text: "Você a tudo que importa",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="8" cy="9" r="2.5" />
        <circle cx="16" cy="9" r="2.5" />
        <path d="M3 19c0-3 2.2-5 5-5s5 2 5 5M11 19c0-3 2.2-5 5-5s5 2 5 5" />
      </svg>
    ),
  },
];

function App() {
  return (
    <main className="page">
      {/* Maps the logos' blue (#1f4fa3) to white while leaving orange untouched,
          so the brand PNGs read on the dark tiles. Keyed on the blue channel. */}
      <svg width="0" height="0" aria-hidden="true" focusable="false">
        <filter id="brand-on-dark" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="1 0 1.66 0 -0.182
                    0 1 1.30 0 -0.143
                    0 0 1.68 0 -0.075
                    0 0 0    1  0"
          />
        </filter>
      </svg>

      <img src={mic} alt="" className="mic" aria-hidden="true" />

      <section className="hero">
        <div className="copy">
          <h1>
            <span>Rádio, TV e</span>
            <strong>Notícia</strong>
            <span>conectando</span>
            <strong>você</strong>
          </h1>
          <p className="tagline">
            As marcas que <em>informam</em>, <em>entretêm</em> e{" "}
            <em>aproximam</em> o público todos os dias.
          </p>
        </div>

        <nav className="tiles" aria-label="Nossos canais">
          {channels.map((channel) => (
            <a key={channel.href} href={channel.href} className="tile">
              <span className="tile-frame">
                <span className="tile-face">
                  <img src={channel.image} alt={channel.name} />
                  {/* Same logo, blue-to-white filtered, clipped to the wordmark
                      half so the icon keeps its navy. */}
                  <img
                    src={channel.image}
                    alt=""
                    aria-hidden="true"
                    className="tile-text"
                  />
                </span>
              </span>
              {channel.city && <span className="city">{channel.city}</span>}
            </a>
          ))}
        </nav>
      </section>

      <footer className="pillars">
        {pillars.map((pillar) => (
          <div key={pillar.title} className="pillar">
            {pillar.icon}
            <div>
              <strong>{pillar.title}</strong>
              <span>{pillar.text}</span>
            </div>
          </div>
        ))}
      </footer>

      <img src={mascot} alt="" className="mascot" aria-hidden="true" />
    </main>
  );
}

export default App;
